import getString from '@/helpers/GetStrings';
import qs from 'qs';

import errorHandler from './errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      readOnly: false,
    };
  },
  methods: {
    saveChanges(toggleEdit = true) {
      if (toggleEdit && this.readOnly === true) {
        this.readOnly = false;
        return;
      }
      if (this.$v) {
        this.$v.$touch();
        if (this.$v.data && this.$v.data.$anyError) {
          this.$q.notify({
            message: 'Check all fields and try again.',
            type: 'warning',
            timeout: 1200,
            position: 'top-right',
          });
          return;
        }
      }
      let data;
      if (typeof this.requestParams() === 'object') {
        data = qs.stringify(this.requestParams(), { arrayFormat: 'brackets' });
      } else {
        data = this.requestParams();
      }
      const id = this.$route.params && this.$route.params.id ? `/${this.$route.params.id}` : '';
      if (data) {
        this.axios({
          method: this.$route.params.id ? 'PUT' : 'POST',
          url: `/${this.endpoint}${id}`,
          data,
        }).then((res) => {
          const successMessage = this.successMessage || getString(`module.${this.module}.edit.save.success`);
          this.$q.notify({
            message: successMessage,
            type: 'positive',
            timeout: 1200,
            position: 'top-right',
          });

          this.readOnly = true;

          this.$store.dispatch('removeEditorState', this.module);
          // Redirect to detail page of the newly created item
          if (res.headers && res.headers.location) {
            if (this.$route.name === 'FaqQuestionAdd') {
              const location = res.headers.location.replace('api/', '');
              this.$router.push(location);
              this.$router.go(0);
            } else {
              const location = res.headers.location.split('/').pop();
              this.$router.push(location);
              this.$router.go(0);
            }
          }
        }).catch((err) => {
          // Handle the error (handleError mixin)
          this.handleError(err);
          console.warn(err);
        });
      } else {
        this.notifyFormError();
      }
    },
  },
};
